module.exports = (eventId, data) => {
    try {
        let params = {}

        if (typeof data === 'string') {
            params[eventId] = data
        } else {
            params = data
        }

        ym(YMCounterId, 'reachGoal', eventId, params)
    } catch (e) {
        console.log(e)
    }
}